/**
 * useRecommendationSelection - Hook for managing recommendation selection state
 */
import { useState, useCallback } from 'react';

export function useRecommendationSelection() {
  const [selectedIndices, setSelectedIndices] = useState<Set<number>>(new Set());

  const toggleItem = useCallback((index: number) => {
    setSelectedIndices((prev) => {
      const next = new Set(prev);
      if (next.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }
      return next;
    });
  }, []);

  const selectAll = useCallback((totalCount: number) => {
    setSelectedIndices(new Set(Array.from({ length: totalCount }, (_, i) => i)));
  }, []);

  const deselectAll = useCallback(() => {
    setSelectedIndices(new Set());
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedIndices(new Set());
  }, []);

  return {
    selectedIndices,
    toggleItem,
    selectAll,
    deselectAll,
    clearSelection,
  };
}
